module.exports = __webpack_public_path__ + "images/vanthart243d6ffc217bd212bf58d632003970df.png";